import React from "react";

export default function ErrorBanner({ message, onRetry }) {
  return (
    <div style={styles.wrap}>
      <p style={styles.msg}>{message || "Something went wrong."}</p>
      {onRetry && (
        <button style={styles.btn} onClick={onRetry}>
          Try again
        </button>
      )}
    </div>
  );
}

const styles = {
  wrap: {
    background: "var(--color-critical-bg)",
    border: "1px solid var(--color-critical)",
    borderRadius: "var(--radius-md)",
    padding: "var(--space-5) var(--space-6)",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "var(--space-4)",
    margin: "var(--space-6)",
  },
  msg: {
    fontSize: "var(--text-sm)",
    color: "var(--color-critical)",
  },
  btn: {
    fontSize: "var(--text-sm)",
    color: "var(--color-critical)",
    textDecoration: "underline",
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: 0,
    whiteSpace: "nowrap",
  },
};
